import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import comet from "../assets/comet.webp";
import PageTransition from "../PageTransition";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet-async";

export default function HeroIntro() {
  const [activated, setActivated] = useState(false);
  const [cursor, setCursor] = useState({ x: 0, y: 0 });
const [hideIntroUI, setHideIntroUI] = useState(false);
const [showSecond, setShowSecond] = useState(false);



  const navigate = useNavigate();

  /* ================= RESET ON REFRESH ================= */
  useEffect(() => {
    setActivated(false);
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  /* ================= CURSOR FOLLOW ================= */
  useEffect(() => {
    const move = (e) => {
      setCursor({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  /* ================= ACTIVATE EXPERIENCE ================= */
const handleActivate = () => {
  if (activated) return;

  setActivated(true);
  document.body.style.overflow = "auto";

  // Hide first-screen UI
  setTimeout(() => {
    setHideIntroUI(true);
  }, 600);

  // Reveal second screen AFTER slide finishes
  setTimeout(() => {
    setShowSecond(true);
  }, 100);
};


  return (
    <>
<Helmet>
  <title>High-Performance Web Design & UX Agency | 2 Light Years</title>
  <meta name="description" content="We design fast, high-converting websites with clear UX and performance optimization." />
  <link rel="canonical" href="https://www.2lightyears.com/" />
  <meta name="robots" content="index, follow" />

</Helmet>
       
                     <PageTransition>
    
      <div className={`home-hero app-bg ${activated ? "activated bg-second" : "bg-first"}`}>
        {/* TAP CIRCLE */}



        <div
          className="tap-circle"
          style={{
            left: cursor.x,
            top: cursor.y,
            opacity: activated ? 0 : 1,
          }}
        >
          Tap anywhere to continue
        </div>

        {/* CURSOR */}
        <div
          className="cursor-dot"
          style={{
            left: cursor.x,
            top: cursor.y,
          }}
        />

        {/* SCREENS */}
        <div className={`screen-wrapper ${activated ? "slide-up" : ""}`}>
          {/* FIRST SCREEN */}
         <section className="screen first-screen" onClick={!hideIntroUI ? handleActivate : undefined}>
  {/* INTRO TEXT LAYER (HIDDEN VIA OPACITY, NOT REMOVED) */}
  <div
    className="text-first-look d-flex flex-column justify-content-end align-items-center"
    style={{
      opacity: hideIntroUI ? 0 : 1,
      visibility: hideIntroUI ? "hidden" : "visible",
      pointerEvents: hideIntroUI ? "none" : "auto",
      transition: "opacity 0.6s ease",
    }}
  >
    <h4 className="text-mint-cream">We Help You to Stay</h4>
    <h1 className="text-wisteria-blue">AHEAD OF THE</h1>
  </div>

  {/* COMET IMAGE — ALWAYS VISIBLE */}
  <div className="img-first-look">
    <img src={comet} className="rocket-image" alt="" />
  </div>
  {/* MOBILE TAP HINT */}
<div
  className={`mobile-tap-hint ${activated ? "hide" : ""}`}
  onClick={!hideIntroUI ? handleActivate : undefined}
>
  <span className="tap-icon"><i class="fa-solid fa-hand-pointer" style={{fontSize: '1rem', border: '1px solid white', padding: '1rem', borderRadius: '50%'}}></i></span>
  <span className="tap-text">Tap to continue</span>
</div>

</section>


          {/* SECOND SCREEN (STATIC BRAND STATEMENT ONLY) */}
          <section className="screen second-screen d-flex flex-column align-items-center">
  <div
    style={{
      opacity: showSecond ? 1 : 0,
      transform: showSecond ? "translateY(0)" : "translateY(30px)",
      transition: "opacity 0.8s ease, transform 0.8s ease",
      textAlign: "center",
    }}
  >
    <h4 className="text-mint-cream">CURVE</h4>
    <h1 className="text-wisteria-blue">
      Stay <span className="text-mint-cream">IILIGHTYEARS</span> Ahead
    </h1>
  </div>
</section>

        </div>

        {/* HEADER */}
        <Header
          visible={activated}
          mode="home"
          activated={activated}
        />

        {/* FOOTER */}
        <Footer
          mode="home"
          activated={activated}
        />
      </div>
      </PageTransition>
    </>
  );
}
